/**
 * @generated SignedSource<<cdca55553429b29c3c41fe08ebf0a5ff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type luminaUserProfilePreviewRelay_user$data = {
  readonly singleUser: {
    readonly __typename: "KnowledgeDiscoverySingleUser";
    readonly user: {
      readonly department: string | null | undefined;
      readonly email: string | null | undefined;
      readonly id: string | null | undefined;
      readonly jobTitle: string | null | undefined;
      readonly location: string | null | undefined;
      readonly name: string | null | undefined;
      readonly organization: string | null | undefined;
      readonly picture: string | null | undefined;
      readonly thirdPartyIntegrations: ReadonlyArray<{
        readonly externalId: string;
        readonly integrationId: string;
        readonly product: string;
      }> | null | undefined;
    } | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly " $fragmentType": "luminaUserProfilePreviewRelay_user";
};
export type luminaUserProfilePreviewRelay_user$key = {
  readonly " $data"?: luminaUserProfilePreviewRelay_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"luminaUserProfilePreviewRelay_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "accountId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "requestingUserId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    }
  ],
  "kind": "Fragment",
  "name": "luminaUserProfilePreviewRelay_user",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "accountId",
          "variableName": "accountId"
        },
        {
          "kind": "Variable",
          "name": "requestingUserId",
          "variableName": "requestingUserId"
        },
        {
          "kind": "Variable",
          "name": "tenantId",
          "variableName": "tenantId"
        }
      ],
      "kind": "LinkedField",
      "name": "singleUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "KnowledgeDiscoveryUserProfile",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "id"
                },
                {
                  "kind": "ScalarField",
                  "name": "name"
                },
                {
                  "kind": "ScalarField",
                  "name": "picture"
                },
                {
                  "kind": "ScalarField",
                  "name": "email"
                },
                {
                  "kind": "ScalarField",
                  "name": "jobTitle"
                },
                {
                  "kind": "ScalarField",
                  "name": "department"
                },
                {
                  "kind": "ScalarField",
                  "name": "location"
                },
                {
                  "kind": "ScalarField",
                  "name": "organization"
                },
                {
                  "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                  "kind": "LinkedField",
                  "name": "thirdPartyIntegrations",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "externalId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "integrationId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "product"
                    }
                  ]
                }
              ]
            }
          ],
          "type": "KnowledgeDiscoverySingleUser"
        }
      ]
    }
  ],
  "type": "KnowledgeDiscoveryQueryApi"
};

(node as any).hash = "99b3d2a21ece6647eaa74c60025403d9";

export default node;
